import { Directive, ElementRef, OnDestroy, inject } from '@angular/core';
import { DragDrop, DragRef } from '@angular/cdk/drag-drop';

/**
 * 모달 헤더를 잡고 모달(.modal-content)을 이동한다.
 * - selector 가 .modal-header 이므로 이 디렉티브를 import 한 컴포넌트의 모달 헤더에 자동으로 적용된다. (NpxCommonModule)
 * - 전체화면(.modal-fullscreen)일 때는 이동하지 않는다.
 */
@Directive({
    selector: '.modal-header',
    standalone: true,
    host: {
        '[class.np-modal-header-drag]': 'true'
    }
})
export class Bs5ModalHeaderDragDirective implements OnDestroy {

    private el: ElementRef<HTMLElement> = inject(ElementRef);
    private dragDrop = inject(DragDrop);

    private dragRef: DragRef | null = null;

    // 모달은 열린 뒤에 .modal-content 안으로 붙으므로, 처음 누를 때 이동 대상을 찾아 연결한다.
    // pointerdown 은 CDK 가 사용하는 mousedown / touchstart 보다 먼저 발생한다.
    private onPointerDown = (event: PointerEvent) => {
        const header = this.el.nativeElement;

        if (!this.dragRef) {
            const modalContent = header.closest<HTMLElement>('.modal-content');
            // 모달 밖에서 .modal-header 클래스를 쓴 경우는 제외
            if (!modalContent) {
                return;
            }
            // withRootElement 는 이동 대상(.modal-content) 전체에 누름 이벤트를 연결하므로, 잡는 곳을 헤더로 한정한다. (본문을 잡으면 이동하지 않게)
            this.dragRef = this.dragDrop.createDrag(header).withRootElement(modalContent).withHandles([header]);
        }

        // 전체화면이거나, 기존 이동 버튼(cdkDragHandle)을 누른 경우는 이 디렉티브로 이동하지 않는다. (두 번 이동 방지)
        const fromDragHandle = !!(event.target as HTMLElement | null)?.closest('.cdk-drag-handle');
        this.dragRef.disabled = !!header.closest('.modal-fullscreen') || fromDragHandle;
    };

    constructor() {
        this.el.nativeElement.addEventListener('pointerdown', this.onPointerDown, true);
    }

    ngOnDestroy(): void {
        this.el.nativeElement.removeEventListener('pointerdown', this.onPointerDown, true);
        this.dragRef?.dispose();
    }
}
